<template>
<div class="modal">
  <div class="black_wrap">
      <svg aria-hidden="true" class="icon common_close" @click="closeDialog">
          <use xlink:href="#icon-close"></use>
      </svg>
      <span class="black_tip">{{showTxt?'黑名单提示':'申诉表单'}}</span>
      <div class="black_content" v-if="showTxt">
        <p class="bc_tit"><b>尊敬的用户，您好：</b></p>
        <p class="bc_txt">我们检测到您在使用AI智能服务过程中使用了敏感信息。根据平台的使用规定，您的账号已被暂时<br />拉入黑名单。在此期间，您将无法使用我们的相关AI智能服务。</p>
        <br />
        <p class="bc_txt">如果您认为这是一个误判，请点击下方的“申诉”按钮，填写并提交申诉表单。我们将尽快处理您<br />的申诉请求。</p>
        <p class="bc_bot">感谢您的理解与配合</p>
      </div>
      <div class="black_content black_edit" v-else>
          <p class="bc_tit"><b>申诉原因：</b></p>
          <el-input type="textarea" resize="none"
          max="500" :show-word-limit="true" v-model="appealTxt"
          placeholder="详细描述您认为被误判的情况，以及相关的使用情况和解释"></el-input>
      </div>
      <p class="tc">
        <span class="btn" @click="goAppeal">{{showTxt?'前往申诉':'提交申诉'}}</span>
      </p>
  </div>
 </div>
</template>
<script>
import { mapState } from "vuex";
import { applyUnlockApi } from '@/api/login.js'
export default {
  name: 'Black',
  data(){
    return{
      showTxt: true,
      appealTxt:''
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods:{
    closeDialog(){
      this.$parent.isBlackUser = false;
      this.showTxt = true;
      this.appealTxt = '';
      this.$bus.$emit("needExit");
    },
    async goAppeal(){
      if (this.showTxt) this.showTxt = false;
      else {
        let res = await applyUnlockApi({
          userId: this.userInfo.userId,
          applyUnlockReason: this.appealTxt,
        });
        if (res.success) {
          this.$message.success('您的申诉已提交，请耐心等待审核结果 ，且不要重复申诉！')
          this.closeDialog()
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.black_wrap{
  position: relative;
  width: 750px;
  height: 426px;
  margin: 15vh auto 0;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 20px;
  background: url(../assets/images/temporary/blackBg.png) no-repeat;
  .black_tip{
    margin-bottom: 10px;
    font-size: 24px;
    color:#fff;
  }
  .black_content{
    width: 690px;
    height: 244px;
    margin-top: 30px;
    padding: 30px;
    box-sizing: border-box;
    background: url(../assets/images/temporary/blackContent.png) no-repeat;
    .bc_txt{
      line-height: 24px;
      text-indent: 2em;
    }
    .bc_tit{
      margin-bottom: 10px;
    }
    .bc_bot{
      margin-top: 30px;
      text-align: right ;
    }
    ::v-deep .el-textarea{
      height: calc(100% - 35px);
      .el-textarea__inner{
        height: 100%;
        border: none;
        padding: 0;
        background: transparent;
        &::placeholder{
          font: 14px Arial, "\5FAE\8F6F\96C5\9ED1";
        }
      }
    }
  }
  .btn{
      display: inline-block;
      width: 98px;
      height: 34px;
      margin-top: 30px;
      line-height: 34px;
      background: #4480EE;
      border-radius: 4px;
      color:#fff;
      cursor: pointer;
  }
}
</style>